import { render } from "./GridDrepturiCustom.vue?vue&type=template&id=5cc336aa&scoped=true&ts=true"
import script from "./GridDrepturiCustom.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiCustom.vue?vue&type=script&lang=ts"

import "./GridDrepturiCustom.vue?vue&type=style&index=0&id=5cc336aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc336aa"]])

export default __exports__